
import { defineComponent } from "vue";

export default defineComponent({
  name: "kt-empty",
  components: {},
});
